// Template JS for Tenders & Procurement (page-tenders-procurement.php)
// Extracted from tenders-procurement-v27.html. Enqueued in footer - DOM is ready.

(function () {
  var section = document.querySelector('.regions-section');
  if (!section) return;
  var tabs = Array.prototype.slice.call(section.querySelectorAll('.region-tab'));
  var panels = Array.prototype.slice.call(section.querySelectorAll('.region-panel'));
  if (!tabs.length || !panels.length) return;

  function activate(id, focus) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-region') === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) t.focus();
    });
    panels.forEach(function (p) {
      var on = p.id === id;
      p.classList.toggle('is-active', on);
      if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      var id = t.getAttribute('data-region');
      activate(id, false);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
    t.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      if (e.key === 'ArrowLeft')  next = (i - 1 + tabs.length) % tabs.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End')  next = tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      activate(tabs[next].getAttribute('data-region'), true);
    });
  });

  section.classList.add('tabs-ready');
  var ids = panels.map(function (p) { return p.id; });
  function fromHash() {
    var hash = (location.hash || '').replace('#', '');
    if (ids.indexOf(hash) > -1) { activate(hash, false); return true; }
    return false;
  }
  if (!fromHash()) activate(ids[0], false);
  window.addEventListener('hashchange', function () {
    if (fromHash()) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

(function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => el.classList.add('in-view'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

  document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => observer.observe(el));

  // ============================================================
  // HERO: Global Delivery Map - traveling pulses + process pills
  // ============================================================
  const heroAnim = document.getElementById('hero-anim');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (heroAnim && !reducedMotion) {
    const svg = heroAnim.querySelector('.delivery-map');
    const travelersGroup = svg.querySelector('#travelers');

    // Arc definitions - bidirectional
    // INBOUND (to Poland HQ): tenders + procurement intake
    // OUTBOUND (from Poland HQ): IT delivery
    const arcs = [
      // === INBOUND tenders (yellow) - RFPs from clients ===
      { id: 'arc-de-in', type: 'tender', duration: 2400, delay: 800 },
      { id: 'arc-uk-in', type: 'tender', duration: 3200, delay: 1200 },
      { id: 'arc-saudi-in', type: 'tender', duration: 3600, delay: 2000 },
      { id: 'arc-uae-in', type: 'tender', duration: 3400, delay: 1500 },
      { id: 'arc-jp-in', type: 'tender', duration: 4600, delay: 2400 },
      { id: 'arc-no-in', type: 'tender', duration: 2800, delay: 1100 },

      // === INBOUND procurement (orange) - supplier qual, contracts ===
      { id: 'arc-ch-in', type: 'procurement', duration: 2200, delay: 1000 },
      { id: 'arc-tx-in', type: 'procurement', duration: 4200, delay: 1800 },
      { id: 'arc-il-in', type: 'procurement', duration: 3800, delay: 2200 },
      { id: 'arc-ca-in', type: 'procurement', duration: 4400, delay: 2400 },
      { id: 'arc-pa-in', type: 'procurement', duration: 4000, delay: 1600 },
      { id: 'arc-usa-in', type: 'procurement', duration: 4100, delay: 2000 },

      // === OUTBOUND IT delivery (blue) - we ship teams + work back ===
      { id: 'arc-de-out', type: 'delivery', duration: 2400, delay: 1200 },
      { id: 'arc-ch-out', type: 'delivery', duration: 2200, delay: 1400 },
      { id: 'arc-uk-out', type: 'delivery', duration: 3200, delay: 1600 },
      { id: 'arc-uae-out', type: 'delivery', duration: 3400, delay: 1800 },
      { id: 'arc-saudi-out', type: 'delivery', duration: 3600, delay: 2200 },
      { id: 'arc-tx-out', type: 'delivery', duration: 4200, delay: 2000 },
      { id: 'arc-il-out', type: 'delivery', duration: 3800, delay: 1800 },
      { id: 'arc-ca-out', type: 'delivery', duration: 4400, delay: 2200 },
      { id: 'arc-pa-out', type: 'delivery', duration: 4000, delay: 1900 },
      { id: 'arc-usa-out', type: 'delivery', duration: 4100, delay: 2100 },
      { id: 'arc-jp-out', type: 'delivery', duration: 4800, delay: 2400 },
      { id: 'arc-no-out', type: 'delivery', duration: 2800, delay: 1300 }
    ];

    const colorMap = {
      tender: '#ffa733',
      procurement: '#fa7f03',
      delivery: '#7192cc'
    };

    // Create one traveling pulse per arc
    function launchTraveler(arc, initialDelay = 0) {
      const path = svg.querySelector('#' + arc.id);
      if (!path) return;

      const pathLength = path.getTotalLength();

      const traveler = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      traveler.setAttribute('r', '2.5');
      traveler.setAttribute('fill', '#fff');
      traveler.setAttribute('class', 'flow-pulse');
      traveler.style.filter = `drop-shadow(0 0 8px ${colorMap[arc.type]}) drop-shadow(0 0 3px ${colorMap[arc.type]})`;
      traveler.style.opacity = '0';
      travelersGroup.appendChild(traveler);

      const start = performance.now() + initialDelay;

      function tick(now) {
        const elapsed = now - start;
        if (elapsed < 0) {
          requestAnimationFrame(tick);
          return;
        }
        const t = (elapsed % (arc.duration + arc.delay)) / arc.duration;
        if (t > 1) {
          traveler.style.opacity = '0';
        } else {
          const point = path.getPointAtLength(t * pathLength);
          traveler.setAttribute('cx', point.x);
          traveler.setAttribute('cy', point.y);
          // Fade in at start, fade out at end
          let alpha = 1;
          if (t < 0.08) alpha = t / 0.08;
          else if (t > 0.92) alpha = (1 - t) / 0.08;
          traveler.style.opacity = alpha;
        }
        requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    // Stagger launches - inbound first (creates "intake" rhythm),
    // then outbound delivery (creates "shipment" rhythm)
    arcs.forEach((arc, i) => {
      // Delivery flows get extra delay so they appear to follow tender intake
      const extraDelay = arc.type === 'delivery' ? 1800 : 0;
      launchTraveler(arc, i * 380 + extraDelay);
    });

    // ----- Floating process pills scheduler -----
    const pills = Array.from(heroAnim.querySelectorAll('.process-pill'));
    let pillIndex = 0;

    function showNextPill() {
      // Hide all
      pills.forEach(p => {
        p.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        p.style.opacity = '0';
      });

      // Show 2 pills at a time (staggered)
      const pillA = pills[pillIndex % pills.length];
      const pillB = pills[(pillIndex + 3) % pills.length];

      setTimeout(() => {
        pillA.style.opacity = '1';
        pillA.style.transform = (pillA.style.transform.includes('translateX')) ? pillA.style.transform : pillA.style.transform + ' translateY(0)';
      }, 200);

      setTimeout(() => {
        pillB.style.opacity = '1';
      }, 1200);

      pillIndex = (pillIndex + 2) % pills.length;
    }

    showNextPill();
    setInterval(showNextPill, 4500);

    // ----- Optional desktop parallax on hero animation container -----
    if (window.matchMedia('(min-width: 992px)').matches) {
      let rafId = null;
      heroAnim.addEventListener('mousemove', (e) => {
        const rect = heroAnim.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;

        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          svg.style.transform = `translate(${x * 8}px, ${y * 8}px)`;
        });
      });

      heroAnim.addEventListener('mouseleave', () => {
        svg.style.transition = 'transform 0.6s ease';
        svg.style.transform = 'translate(0, 0)';
        setTimeout(() => { svg.style.transition = ''; }, 600);
      });
    }
  }

})();
